import { IconPhone } from "@tabler/icons-react";
import AOS from "aos";
import "aos/dist/aos.css";
import React from "react";
import { IconArrowNarrowRight } from "@tabler/icons-react";

const Digital = () => {
  return (
    <div>
      <section className="section relative">
        <img
          alt="element"
          width="482"
          height="413"
          src="assets/images/element-3.png"
          className="animate-rotate absolute left-20 top-20 hidden xxl:block"
        />
        <div className="container relative z-[1]">
          <div className="grid grid-cols-12 items-center gap-6">
            <div className="col-span-12 xl:col-span-6">
              <div className="grid grid-cols-12 gap-6" data-aos="fade-right">
                <div className="col-span-12 md:col-span-6 xxxl:translate-y-20">
                  <div className="grid grid-cols-12 gap-6">
                    <div className="col-span-12 sm:col-span-6 md:col-span-12">
                      <div
                        className="flex flex-col items-center rounded-xl p-10"
                        style={{
                          backgroundColor: "#7D42FB",
                          color: "rgb(0, 109, 178)",
                        }}
                      >
                        <div className="rounded-full bg-n8 p-3">
                          <img
                            width="24"
                            height="24"
                            src="assets/images/icon-24.png"
                            alt="image"
                          />
                        </div>
                        <h5 className="h5 mt-6 text-center font-semibold text-n8">
                          Experts Problem Solvers
                        </h5>
                      </div>
                    </div>
                    <div className="sm:col-sm-6 col-span-12 md:col-span-12">
                      <div
                        className="h-100 flex flex-col items-center rounded-xl p-10"
                        style={{ backgroundColor: "#FF813A" }}
                      >
                        <div className="rounded-full bg-n8 p-3">
                          <img
                            width="24"
                            height="24"
                            src="assets/images/icon-27.png"
                            alt="image"
                          />
                        </div>
                        <h5 className="h5 mt-6 text-center font-semibold text-n8">
                          Top-Notch, Real-time Customer Service
                        </h5>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-span-12 md:col-span-6">
                  <div className="grid grid-cols-12 gap-6">
                    <div className="col-span-12 sm:col-span-6 md:col-span-12">
                      <div
                        className="h-100 flex flex-col items-center rounded-xl p-10"
                        style={{ backgroundColor: "#FF4267" }}
                      >
                        <div className="rounded-full bg-n8 p-3">
                          <img
                            width="24"
                            height="24"
                            src="assets/images/icon-26.png"
                            alt="image"
                          />
                        </div>
                        <h5 className="h5 mt-6 text-center font-semibold text-n8">
                          Regular Updates & Bug fixes
                        </h5>
                      </div>
                    </div>
                    <div className="col-span-12 sm:col-span-6 md:col-span-12">
                      <div
                        className="flex flex-col items-center rounded-xl p-10"
                        style={{ backgroundColor: "#2AAF88" }}
                      >
                        <div className="rounded-full bg-n8 p-3">
                          <img
                            width="24"
                            height="24"
                            src="assets/images/icon-25.png"
                            alt="image"
                          />
                        </div>
                        <h5 className="h5 mt-6 text-center font-semibold text-n8">
                          Analysis of Creative Product and Services
                        </h5>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-span-12 xl:col-span-6 ms-5" data-aos="fade-left">
              <h5 className="h5 mb-5 " style={{ color: " rgb(0, 109, 178)" }}>
                What Makes Cognity Stand Out
              </h5>
              <h3 className="h3 mb-4 text-title">
                Digital Technology, IT Solutions, and Service Providers
                Worldwide
              </h3>
              <p
                className="mb-10 max-w-lg lg:mb-14"
                style={{ fontSize: "18px" }}
              >
                Bring win-win survival techniques to the table in order to
                assure dotted proactive control. At the end of the day, moving
                ahead, there will be a new normal that has developed.
              </p>

              <div className="mt-12 flex flex-wrap gap-6">
                <a href="/about-us" className="btn-primary">
                  About us
                  <IconArrowNarrowRight className="text-blue-600 w-6 h-6" />
                </a>
                <div className="flex shrink-0 items-center gap-4">
                  <div
                    className="flex items-center justify-center rounded-full border border-gray p-3 "
                    style={{ color: "rgb(0, 109, 178)" }}
                  >
                    <IconPhone size={24} />
                  </div>
                  <div className="group-0 group">
                    <p className="text-sm text-title">Call for Help</p>
                    <a
                      href="tel:(+91)00000-00000"
                      className="font-medium text-title"
                    >
                      {" "}
                     (+91) 00000-00000{" "}
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Digital;
